import { render, staticRenderFns } from "./InfoInicial.vue?vue&type=template&id=9ec7352a&"
import script from "./InfoInicial.vue?vue&type=script&lang=js&"
export * from "./InfoInicial.vue?vue&type=script&lang=js&"
import style0 from "./InfoInicial.vue?vue&type=style&index=0&id=9ec7352a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports